import { all } from 'redux-saga/effects';
import InterviewSaga from './interviewSaga';
import PlatformSaga from './platformSaga';
export default function* rootSaga() {
    yield all([InterviewSaga(), PlatformSaga()]);
}
